export enum Actions {
  REBOOT_DEVICE_SUCCESS = 'REBOOT_DEVICE_SUCCESS',
  REBOOT_DEVICE_FAILURE = 'REBOOT_DEVICE_FAILURE',
  REBOOT_DEVICE = 'REBOOT_DEVICE',
  RESET_DEVICE_SUCCESS = 'RESET_DEVICE_SUCCESS',
  RESET_DEVICE_FAILURE = 'RESET_DEVICE_FAILURE',
  RESET_DEVICE = 'RESET_DEVICE',
}

export enum DeviceState {
  failed = 'failed',
  success = 'success',
  pending = 'pending'
}

export const deviceManagementEndpoint = 'lifesize.deviceInfo';
export const deviceManagementRebootUri = 'device/reboot';
export const deviceManagementResetUri = 'device/reset';
